import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

import Home from "../views/Home.vue";
import ShowPass from "@/views/ShowPass.vue";
import ShowQRCode from "@/views/ShowQRCode.vue";
import Reset from "@/views/Reset.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Home",
    meta: { title: "QRPass" },
    component: Home
    // component: () => import(/* webpackChunkName: "home" */ "../views/Home.vue"),
  },
  {
    path: "/h/:id",
    name: "ShowPass",
    component: ShowPass,
    meta: { title: "QRPass" }
  },
  {
    path: "/q",
    name: "Show Code",
    meta: { title: "QRPass" },
    component: ShowQRCode
    // component: () => import(/* webpackChunkName: "home" */ "../views/ShowQRCode.vue"),
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () =>
    //   import(/* webpackChunk----Name: "about" */ "../vwwwiews/sssAbout.vue")
  },
  {
    path: "/reset",
    // name: "Reset",
    component: Reset
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

export default router;

const DEFAULT_TITLE = "QRPass";
router.afterEach((to, from) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    document.title = to.meta.title || DEFAULT_TITLE;
  });
});
